<template>
  <div>
    <div v-if="displayEnrolledCourses.length > 0" class="bg-white rounded-2xl shadow-sm mb-6">
      <div class="flex flex-col-reverse gap-3 md:flex-row md:justify-between md:items-center px-4 pt-4 pb-2 sm:px-6 sm:pt-6 sm:pb-2 lg:px-8 lg:pt-8 lg:pb-2">
        <div class="space-y-1 md:space-y-4">
          <h2 class="text-2xl md:text-3xl font-bold">Mis Cursos</h2>
        </div>
        <div v-if="displayEnrolledCourses.length > 0" class="flex items-center gap-2">
          <span class="text-sm text-neutral-500 hidden sm:inline">Vista de tarjetas:</span>
          <div class="inline-flex rounded-lg p-0.5 bg-neutral-100" role="group">
            <button
              type="button"
              :class="[
                'px-3 py-1.5 text-xs font-medium rounded-md transition-colors',
                courseCardStyle === 'gradient' ? 'bg-white shadow text-neutral-800' : 'text-neutral-600 hover:text-neutral-800'
              ]"
              @click="setCourseCardStyle('gradient')"
              title="Gradientes de color"
            >Gradientes</button>
            <button
              type="button"
              :class="[
                'px-3 py-1.5 text-xs font-medium rounded-md transition-colors',
                courseCardStyle === 'white' ? 'bg-white shadow text-neutral-800' : 'text-neutral-600 hover:text-neutral-800'
              ]"
              @click="setCourseCardStyle('white')"
              title="Fondo blanco"
            >Blanco</button>
            <button
              type="button"
              :class="[
                'px-3 py-1.5 text-xs font-medium rounded-md transition-colors',
                courseCardStyle === 'primary-blues' ? 'bg-white shadow text-neutral-800' : 'text-neutral-600 hover:text-neutral-800'
              ]"
              @click="setCourseCardStyle('primary-blues')"
              title="Estilo oscuro"
            >Oscuro</button>
          </div>
        </div>
      </div>
      <div class="tabs-content">
        <div v-if="moduleLoaded" class="rounded-lg px-4 pt-2 pb-4 sm:px-6 sm:pt-2 sm:pb-6 lg:px-8 lg:pt-2 lg:pb-8">
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full">
            <CourseCard
              :course="course"
              :index="index"
              :card-style="courseCardStyle"
              class="flex-1"
              v-for="(course, index) in displayEnrolledCourses"
              :key="course.isOlympic ? `olympic-${course.slug || course.id}` : course.id"
              ref="coursesContainer"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-2xl shadow-sm" :class="{ 'mt-6': displayEnrolledCourses.length > 0 }">
      <div class="flex flex-col-reverse gap-3 md:flex-row md:justify-between md:items-center px-4 pt-4 pb-2 sm:px-6 sm:pt-6 sm:pb-2 lg:px-8 lg:pt-8 lg:pb-2">
        <div class="space-y-1 md:space-y-4">
          <h2 class="text-2xl md:text-3xl font-bold">Explorar Cursos</h2>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-500 hidden sm:inline">Vista de tarjetas:</span>
          <div class="inline-flex rounded-lg p-0.5 bg-neutral-100" role="group">
            <button
              type="button"
              :class="[
                'px-3 py-1.5 text-xs font-medium rounded-md transition-colors',
                courseCardStyle === 'gradient' ? 'bg-white shadow text-neutral-800' : 'text-neutral-600 hover:text-neutral-800'
              ]"
              @click="setCourseCardStyle('gradient')"
              title="Gradientes de color"
            >Gradientes</button>
            <button
              type="button"
              :class="[
                'px-3 py-1.5 text-xs font-medium rounded-md transition-colors',
                courseCardStyle === 'white' ? 'bg-white shadow text-neutral-800' : 'text-neutral-600 hover:text-neutral-800'
              ]"
              @click="setCourseCardStyle('white')"
              title="Fondo blanco"
            >Blanco</button>
            <button
              type="button"
              :class="[
                'px-3 py-1.5 text-xs font-medium rounded-md transition-colors',
                courseCardStyle === 'primary-blues' ? 'bg-white shadow text-neutral-800' : 'text-neutral-600 hover:text-neutral-800'
              ]"
              @click="setCourseCardStyle('primary-blues')"
              title="Estilo oscuro"
            >Oscuro</button>
          </div>
        </div>
      </div>
      <div class="tabs-content">
        <div v-if="moduleLoaded" class="rounded-lg px-4 pt-2 pb-4 sm:px-6 sm:pt-2 sm:pb-6 lg:px-8 lg:pt-2 lg:pb-8">
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full"
            v-if="availableCourses.length > 0">
            <CourseCard
              :course="course"
              :index="index"
              :card-style="courseCardStyle"
              class="flex-1"
              v-for="(course, index) in availableCourses"
              :key="course.title"
              ref="coursesContainer"
            />
          </div>
          <MobEmptyState v-else text="Este módulo no está disponible" image="/images/empty-states/student-stats.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MobTabs, MobEmptyState } from "@/views/V2/components";
import CourseCard from "./CourseCard.vue";
import { getEnrolledOlympics } from "@/services/olympics.service";

export default {
  name: "CourseNavigation",
  
  components: {
    MobTabs,
    CourseCard,
    MobEmptyState,
  },

  data() {
    return {
      moduleLoaded: false,
      courseCardStyle: (typeof localStorage !== 'undefined' && localStorage.getItem('courseCardStyle')) || 'white',
      olympicCards: [],
    };
  },

  computed: {
    enrolledCourses() {
      const enrolled = this.$store.state.dashboardCache?.enrolledModules ?? [];
      return enrolled
        .filter((m) => m.id !== 636)
        .map((m) => ({ ...m, content: m.id }));
    },
    displayEnrolledCourses() {
      if (!this.olympicCards.length) return this.enrolledCourses;
      return [...this.olympicCards, ...this.enrolledCourses];
    },
    availableCourses() {
      const available = this.$store.state.dashboardCache?.availableModules ?? [];
      return available.map((m) => ({ ...m, content: m.id }));
    },
  },

  methods: {
    setCourseCardStyle(style) {
      this.courseCardStyle = style;
      if (typeof localStorage !== 'undefined') localStorage.setItem('courseCardStyle', style);
    },
    async loadOlympicCard() {
      try {
        const { data } = await getEnrolledOlympics();
        const olympics = (Array.isArray(data) ? data : []).filter(
          (o) => o.active === true
        );
        this.olympicCards = olympics.map((olympic) => ({
          id: olympic.moduleId || olympic.id,
          olympicId: olympic.id,
          isOlympic: true,
          enrolled: true,
          title: olympic.title || olympic.description || "Olimpiada",
          description: olympic.description || "Participa en las fases de la olimpiada",
          icon: olympic.icon,
          progressPercentage: null,
          hidden: olympic.hidden === true,
          slug: olympic.slug,
        }));
      } catch (e) {
        console.error("Error loading olympic cards:", e);
        this.olympicCards = [];
      }
    },
  },

  async mounted() {
    const loader = this.$loading.show({ container: this.$refs.coursesContainer });
    try {
      await this.$store.dispatch("dashboardCache/fetchDashboardDataIfNeeded");
      await this.loadOlympicCard();
    } catch (err) {
      console.error("Error loading modules:", err);
    } finally {
      loader.hide();
      this.moduleLoaded = true;
    }
  },
  async activated() {
    try {
      await this.$store.dispatch("dashboardCache/fetchDashboardDataIfNeeded");
      await this.loadOlympicCard();
      this.moduleLoaded = true;
    } catch (err) {
      console.error("Error loading modules:", err);
    }
  },
};
</script>
